import React from 'react';
import { FaExclamationTriangle, FaTrash, FaQuestionCircle, FaInfoCircle } from 'react-icons/fa';
import './DeleteConfirmationModal.css';

function ConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action",
  message,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  type = "danger", // 'danger', 'warning', 'info', 'question'
  isLoading = false
}) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (!isLoading) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <FaTrash className="confirmation-modal-icon danger" />;
      case 'warning':
        return <FaExclamationTriangle className="confirmation-modal-icon warning" />;
      case 'info':
        return <FaInfoCircle className="confirmation-modal-icon info" />;
      case 'question':
      default:
        return <FaQuestionCircle className="confirmation-modal-icon question" />;
    }
  };

  const getLoadingText = () => {
    switch (type) {
      case 'danger':
        return 'Deleting...';
      default:
        return 'Processing...';
    }
  };

  return (
    <div className="delete-modal-overlay" onClick={handleOverlayClick}>
      <div className="delete-modal-content">
        <div className="delete-modal-header">
          <div className="confirmation-modal-title-container">
            {getIcon()}
            <h2 className="delete-modal-title">{title}</h2>
          </div>
        </div>
        
        <div className="delete-modal-body">
          <p className="delete-modal-message">{message}</p>
        </div>
        
        <div className="delete-modal-actions">
          <button 
            type="button"
            onClick={handleCancel}
            disabled={isLoading}
            className="delete-modal-cancel-btn"
          >
            {cancelButtonText}
          </button>
          <button 
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className={`delete-modal-confirm-btn ${type}`}
          >
            {isLoading ? getLoadingText() : confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
}

// Backward compatibility
export default ConfirmationModal;
export { ConfirmationModal }; 